import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { DefaultTFuncReturn } from "i18next"
import { useEffect, useState } from "react"
import { empresaActivaStore } from "utils/local-storage-key-store"

export interface ActiveCompanyChangedModalProps {
  confirmButtonLabel?: DefaultTFuncReturn
  icon?: IconName
  isLoading?: boolean
  onConfirm?: () => void
  paragraph?: DefaultTFuncReturn
  title?: DefaultTFuncReturn
}

export const ActiveCompanyChangedModal = ({
  confirmButtonLabel,
  isLoading,
  onConfirm,
  paragraph,
  title,
  icon = "trash-alt",
}: ActiveCompanyChangedModalProps) => {
  const [showActiveCompanyModal, setShowActiveCompanyModal] =
    useState<boolean>(false)

  useEffect(() => {
    const currentEmpresa = empresaActivaStore.get()
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "empresaActiva" && event.newValue !== currentEmpresa) {
        setShowActiveCompanyModal(true)
      } else if (event.newValue === currentEmpresa) {
        setShowActiveCompanyModal(false)
      }
    }
    window.addEventListener("storage", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  return (
    <PrimeReactModal
      visible={showActiveCompanyModal}
      className='tw-w-80 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={40}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div className='tw-flex tw-flex-col tw-px-4 tw-pb-1 tw-gap-3'>
          {confirmButtonLabel && (
            <ButtonPrimeReact
              label={!isLoading ? `${confirmButtonLabel}` : undefined}
              className='tw-w-full tw-h-12 !tw-bg-primary tw-text-simple-10 tw-items-center data-[isloading=true]:!tw-bg-primary-75 data-[isloading=true]:tw-cursor-not-allowed'
              data-isloading={isLoading}
              onClick={onConfirm}
              loading={isLoading}
            />
          )}
        </div>
      }
    >
      <>
        <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
          <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
            <FontAwesomeIcon
              icon={["fal", icon]}
              className='tw-w-8 tw-h-8 tw-text-danger'
            />
          </div>
        </div>
        {Boolean(title) && (
          <div className='tw-text-xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
            {title}
          </div>
        )}
        {Boolean(paragraph) && (
          <div className='tw-w-full tw-flex tw-flex-col tw-text-center tw-px-4'>
            <p className='tw-mb-3 tw-text-lg'>{paragraph}</p>
          </div>
        )}
      </>
    </PrimeReactModal>
  )
}
